import { Component, ElementRef, Input, OnInit } from '@angular/core';
import { NbMenuService } from '@nebular/theme';
import { MenuGroup } from '../../dynamic-input-model';

@Component({
  selector: 'ngx-footer-input',
  templateUrl: './footer-input.component.html',
  styleUrls: ['./footer-input.component.scss']
})
export class FooterInputComponent implements OnInit {
  @Input() data:any;
  defaultMenuTag:string; 
  topLevelMenuTag = "editFooterMenu";
  //Used in ngSwitch to select content to show without click event.
  defaultInputMenuItem:string;
  //activeInputMenuItem: Used in ngSwitch to select content to show.  Triggered by menu click.
  activeInputMenuItem:string;
  menuGroups:any;
  //selectedMenuItem = 
  menuItemTitle:string;

  constructor(
    private el:ElementRef, 
    private menuService:NbMenuService
  ) { }

  ngOnInit(): void {
    this.menuGroups = this.data;
    console.log(this.menuGroups);
    let topLevelMenu:MenuGroup = this.menuGroups["topLevelMenu"];
    if(topLevelMenu != undefined){
      this.defaultMenuTag = topLevelMenu.menuTag;
      this.defaultInputMenuItem = topLevelMenu.menuItems[0].title;
      this.activeInputMenuItem = this.defaultInputMenuItem;
    }
    this.menuService.onItemClick().subscribe(menuBag =>{
      console.log({menuBag:menuBag});
      let selectedItem = menuBag.item;
      if(selectedItem != undefined){
        //if(selectedItem.parent.title)
        console.log({selectedItem:selectedItem});
        this.activeInputMenuItem = selectedItem.title;
      }
    })
  }

  tabChanged(e){

  }

}
